import { Suspense } from "react";
import HeaderWebsite from "../../components/HeaderWebsite";
import LandingPage from "../../components/LandingPage";

export default function CoursePage(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
  } = props;

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <LandingPage />
      </Suspense>
    </>
  );
}
